import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getUserImage, updateUserProfile, updateUserProfileImage, viewUserProfile } from '../../Redux/User/action';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IMAGE_URL } from '../../api';
import { getTaskCategoryList } from '../../Redux/Task/action';
import ToasterMessage from '../ToasterMessage';
import loader from '../../assets/img/loader.gif';
import { useDispatch, useSelector } from "react-redux";
import { setUserLoginDetails } from '../../slices/user/userSlice';


const ManageProfile = () => {
    const dispatch = useDispatch()
    const users = useSelector((state) => state.user);


    const [user, setUser] = useState({})
    const [userImage, setUserImage] = useState('');
    const [categories, setCategories] = useState();
    const [toaster, setToaster] = useState("");
    const [isloader, setIsloader] = useState(false);

    useEffect(() => {
        viewUserProfile()((response) => {
            if (response && response.status) {
                setUser(response?.data?.data)
                formik.setValues({
                    ...formik.values,
                    name: response?.data?.data[0]?.full_name?.full_name,
                    email: response?.data?.data[0]?.user?.email,
                    phone: response?.data?.data[0]?.user?.phone,
                    address1: response?.data?.data[0]?.address[0]?.address1,
                    address2: response?.data?.data[0]?.address[0]?.address2,
                    city: response?.data?.data[0]?.address[0]?.city,
                    gender: response?.data?.data[0]?.user?.gender,
                    pan: response?.data?.data[0]?.pan_number,
                    primary_service: response?.data?.data[0]?.primary_service?.id,
                    secondary_service: response?.data?.data[0]?.secondary_service?.id,
                    about: response?.data?.data[0]?.about_user,
                    business_type: response?.data?.data[0]?.address[0]?.business_type,
                    zip_code: response?.data?.data[0]?.address[0]?.zip_code,
                })
            }

            getImage()
        });
        getTaskCategoryList()((response) => {
            if (response && response.status) {
                setCategories(response?.data?.data)
            }


        });
    }, []);
    const getImage = () => {
        getUserImage()((response) => {
            if (response && response.status) {
                setUserImage(response?.data?.image)
                localStorage.setItem('user_image', response?.data?.image);
            }


        });
    }
    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required('Required'),
        email: Yup.string()
            .required('Required'),
        phone: Yup.string().matches(/^[6-9]\d{9}$/, 'Enter a valid mobile number')
            .required('Required'),
        // address1: Yup.string()
        //     .required('Required'),
        // address2: Yup.string()
        //     .required('Required'),
        // city: Yup.string()
        //     .required('Required'),
        gender: Yup.string()
            .required('Required'),
        // pan: Yup.string()
        //     .required('Required'),
        // primary_service: Yup.string()
        //     .required('Required'),
        // secondary_service: Yup.string()
        // .required('Required'),
        // about: Yup.string()
        //     .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            address1: "",
            address2: "",
            zip_code: "",
            city: "",
            gender: "",
            pan: "",
            primary_service: "",
            secondary_service: "",
            about: "",
            business_type: "",

        },
        validationSchema,
        onSubmit: (values) => {
            var address = [
                {
                    address1: formik.values.address1,
                    address2: formik.values.address2,
                    business_type: formik.values.business_type,
                    zip_code: formik.values.zip_code,
                    city: formik.values.city,

                }
            ]
            var userData =
            {
                full_name: formik.values.name,
                email: formik.values.email,
                phone: formik.values.phone,
                gender: formik.values.gender,
            }
            setIsloader(true)
            updateUserProfile(address, userData, formik.values.pan, formik.values.primary_service, formik.values.secondary_service, formik.values.about, formik.values.address1, formik.values.address2, formik.values.city)((response) => {
                if (response && response.status) {
                    let first_name = formik.values.name.split(' ')[0] ?? ""
                    let last_name = formik.values.name.split(' ')[1] ?? ""
                    dispatch(
                        setUserLoginDetails({
                            ...users,
                            email: formik.values.email,
                            first_name: first_name,
                            last_name: last_name,
                            phone: formik.values.phone,
                        })
                    );
                }
                setIsloader(false)
                setToaster("Save Changes")
                setTimeout(() => {
                    setToaster("")

                }, 2000);
            });
        },
    });
    const onChangeImage = (e) => {

        let formData = new FormData();
        formData.append('image', e.target.files[0])
        updateUserProfileImage({ formData })((response) => {
            if (response && response.status) {
                getImage()
            }
        });
    }
    return (
        <React.Fragment>
            <Header />
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Manage Profile </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Manage Profile</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='edit-profile'>
                <div className="container bootstrap snippets bootdey">
                    <h1 className="text-primary mb-2">Edit Profile</h1>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="text-center">
                                <img src={userImage ? userImage : ""} className="avatar img-circle img-thumbnail" alt="avatar" />
                                {/* <h6>Upload a different photo...</h6> */}

                                <input type="file" className="form-control mb-3" onChange={(e) => onChangeImage(e)} />
                            </div>
                        </div>

                        <div className="col-md-9 personal-info">
                            <h3>Personal info</h3>
                            <div className='wrapper-form'>
                                <Form onSubmit={formik.handleSubmit}>
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Label>Full Name <span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={formik.values?.name}
                                                    onChange={formik.handleChange}
                                                    maxLength="30"
                                                    placeholder="Enter Full Name"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-6'>
                                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                                <Form.Label>Email Address <span>*</span></Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    maxLength={40}
                                                    value={formik.values?.email}
                                                    onChange={formik.handleChange}
                                                    placeholder="Enter Email Address"
                                                    disabled
                                                />
                                            </Form.Group>
                                        </div>

                                        <div className='col-lg-6'>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Label>Mobile Number <span>*</span></Form.Label>
                                                <Form.Control
                                                    name="phone"
                                                    type="tel"
                                                    maxLength={10}
                                                    value={formik.values?.phone}
                                                    onChange={formik.handleChange}
                                                    placeholder="Enter Mobile Number"
                                                    disabled
                                                />
                                            </Form.Group>
                                        </div>
                                        {localStorage.getItem('user_type') && localStorage.getItem('user_type') == 2 &&
                                            <div className='col-lg-6'>
                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>Address 1 <span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="address1"
                                                        value={formik.values.address1}
                                                        maxLength={500}
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter Address1"
                                                    />
                                                </Form.Group>
                                            </div>
                                        }

                                        {localStorage.getItem('user_type') && localStorage.getItem('user_type') == 2 &&
                                            <React.Fragment>
                                                <div className='col-lg-6'>
                                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                                        <Form.Label>Address 2 <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="address2"
                                                            value={formik.values.address2}
                                                            onChange={formik.handleChange}
                                                            maxLength={500}
                                                            placeholder="Enter Address2" />
                                                    </Form.Group>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                                        <Form.Label>City <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="city"
                                                            value={formik.values.city}
                                                            maxLength={40}
                                                            onChange={formik.handleChange}
                                                            placeholder="Enter City"
                                                        />
                                                    </Form.Group>
                                                </div>

                                            </React.Fragment>

                                        }
                                        {localStorage.getItem('user_type') && localStorage.getItem('user_type') == 2 &&
                                            <div className='col-lg-6'>
                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>Zip Code <span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="zip_code"
                                                        value={formik.values.zip_code}
                                                        maxLength={6}
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter Zip Code"
                                                    />
                                                </Form.Group>
                                            </div>
                                        }
                                        <div className='col-lg-6'>
                                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                                <Form.Label>Gender <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                <div className="mb-3">
                                                    <Form.Check
                                                        inline
                                                        label="Male"
                                                        value="M"
                                                        checked={formik.values?.gender == 'M' ? true : false}
                                                        name="gender"
                                                        onChange={formik.handleChange}
                                                        type="radio"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Female"
                                                        value="F"
                                                        checked={formik.values?.gender == 'F' ? true : false}
                                                        name="gender"
                                                        onChange={formik.handleChange}
                                                        type="radio"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Other"
                                                        checked={formik.values?.gender == 'O' ? true : false}
                                                        value="O"
                                                        name="gender"
                                                        onChange={formik.handleChange}
                                                        type="radio"
                                                    />
                                                </div>

                                            </Form.Group>
                                        </div>
                                        {localStorage.getItem('user_type') && localStorage.getItem('user_type') == 2 &&
                                            <div className='col-lg-6'>
                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>PAN Number <span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="pan"
                                                        value={formik.values.pan}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}
                                                        placeholder="Enter PAN Number"
                                                    />
                                                </Form.Group>
                                            </div>
                                        }
                                        {localStorage.getItem('user_type') && localStorage.getItem('user_type') == 2 &&
                                            <React.Fragment>
                                                <div className='col-lg-6'>
                                                    <Form.Label>Primary Services <span>*</span></Form.Label>
                                                    <Form.Select className="mb-3" name="primary_service" value={formik.values.primary_service} onChange={formik.handleChange} aria-label="Default select example">
                                                        <option value="">Primary Services</option>
                                                        {categories?.map((category, index) =>
                                                            <option key={index} value={category?.id}>{category?.name}</option>
                                                        )}
                                                        {/* <option value="1">Astro</option>
                                                        <option value="2">Tax</option>
                                                        <option value="3">Heal</option>
                                                        <option value="4">Digital</option> */}
                                                    </Form.Select>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <Form.Label>Secondary Services <span>*</span></Form.Label>
                                                    <Form.Select className="mb-3" name="secondary_service" value={formik.values.secondary_service} onChange={formik.handleChange} aria-label="Default select example">
                                                        <option value="">Secondary Services</option>
                                                        {categories?.map((category, index) =>
                                                            <option key={index} value={category?.id}>{category?.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <Form.Label>Business Type <span>*</span></Form.Label>
                                                    <Form.Select aria-label="Default select example" name='business_type' value={formik.values?.business_type} required onChange={formik.handleChange}>
                                                        <option value="">Select Type</option>
                                                        <option value={"llp"}>LLP</option>
                                                        <option value={"ngo"}>NGO</option>
                                                        <option value={"individual"}>INDIVIDUAL</option>
                                                        <option value={"private_limited"}>PRIVATE LIMITED</option>
                                                        <option value={"other"}>OTHER</option>
                                                    </Form.Select>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label>About Yourself <span>*</span></Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            name="about"
                                                            value={formik.values.about}
                                                            onChange={formik.handleChange}
                                                            rows={3}
                                                            maxLength={300}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className='mb-5 mt-5'>
                                                <div className='editprofile-btn'>
                                                    {isloader == true ?
                                                        <div className='loader'>
                                                            <img src={loader} alt="" className='img-fluid' />
                                                        </div>
                                                        :
                                                        <button type="submit" className="btn btn-primary">Save Changes</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default ManageProfile;